import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    class: "d-flex justify-content-center align-items-center bg-light",
    style: { "height": "70vh" }
};
const _hoisted_2 = { class: "container col-md-4" };
const _hoisted_3 = { class: "card p-4" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h1", { class: "h4 mb-4 text-center" }, "Recuperar Contraseña", -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "text-center mb-4" }, " Ingresa tu correo electrónico para recibir instrucciones para restablecer tu contraseña. ", -1 /* HOISTED */);
const _hoisted_6 = { class: "mb-3" };
const _hoisted_7 = { class: "d-grid gap-2" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_10 = { class: "text-center mt-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createCommentVNode(" Formulario de Recuperación de Contraseña "),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("form", {
                        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handlePasswordRecovery && _ctx.handlePasswordRecovery(...args)), ["prevent"]))
                    }, [
                        _hoisted_4,
                        _hoisted_5,
                        _createCommentVNode(" Correo Electrónico "),
                        _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.email) = $event)),
                                type: "email",
                                class: "form-control",
                                placeholder: "Correo Electrónico",
                                required: "",
                                autocomplete: "email"
                            }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, _ctx.email]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary",
                                disabled: _ctx.loading
                            }, [
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(" Recuperar Contraseña ")
                            ], 8 /* PROPS */, _hoisted_8)
                        ]),
                        _createCommentVNode(" Mensaje de Error o Éxito "),
                        (_ctx.message)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: _normalizeClass([
                                    'mt-3',
                                    _ctx.messageType === 'error' ? 'text-danger' : 'text-success',
                                    'text-center',
                                ])
                            }, _toDisplayString(_ctx.message), 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true)
                    ], 32 /* NEED_HYDRATION */)
                ]),
                _createCommentVNode(" Enlace para regresar al inicio de sesión "),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", null, [
                        _createTextVNode(" ¿Recuperaste tu contraseña? "),
                        _createVNode(_component_router_link, {
                            to: "/login",
                            class: "link-primary"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("Inicia sesión aquí")
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ])
        ])
    ], 64 /* STABLE_FRAGMENT */));
}
